var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAttach = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 23"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.188 5.25v11.979a4.166 4.166 0 0 1-4.167 4.167 4.166 4.166 0 0 1-4.167-4.167V4.209a2.605 2.605 0 0 1 5.209 0v10.937c0 .573-.47 1.041-1.042 1.041a1.045 1.045 0 0 1-1.042-1.041V5.25H3.417v9.896a2.605 2.605 0 0 0 5.208 0V4.208A4.166 4.166 0 0 0 4.458.042 4.166 4.166 0 0 0 .292 4.208V17.23a5.726 5.726 0 0 0 5.729 5.73 5.726 5.726 0 0 0 5.73-5.73V5.249z"
})));
export default SvgAttach;